import { cloneDeep, get } from 'lodash';

/** Take a validationResult, find and replace the error message with a regex pattern
 *
 * @param {Object} validationResult   A single validationResult.
 * @param regex  Regex pattern (e.g. /(\d)\w+/)
 * @param {Function} transform  A function that takes the output from the regex and transforms it to something else
 */
export const transformValidationMessage = (validationResult, regex, transform) => {
  if (!validationResult || !validationResult.helpMessages) {return validationResult;}
  let newValidation = cloneDeep(validationResult);
  const helpMessage = get(newValidation, 'helpMessages[0]', null);
  if (helpMessage) {
    const match = regex.exec(helpMessage);
    if (!match) {return newValidation;}
    const newMatch = transform(match[0]);
    const newHelpMessage = helpMessage.replace(match[0], newMatch);
    newValidation.helpMessages[0] = newHelpMessage;
  }
  return newValidation;
};